export default __webpack_public_path__ + "static/media/add-tag-listing-white.d7c1aaef.svg";